import React from 'react';
import cx from 'classnames';

import { assetUrl } from '~/helpers';

export interface DownloadAppBannerProps {
  className?: string;
}

export default function DownloadAppBanner({
  className,
}: DownloadAppBannerProps) {
  return (
    <div
      className={cx(
        'flex flex-wrap justify-center items-center bg-neutral-100 rounded-md p-5 gap-5',
        className
      )}
    >
      <img
        className='max-w-[80px]'
        src={assetUrl('assets/images/download-banner/download.png')}
        alt='download'
      />
      <div className='flex-1 flex flex-col items-center'>
        <h4 className='text-xl text-neutral-900 mt-0 mb-4 font-circular text-center'>
          Record from your phone! Try our app today
        </h4>
        <div className='flex gap-5'>
          <a
            href='https://apps.apple.com/us/app/bonjoro/id1091131644'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              className='max-h-[40px]'
              src={assetUrl('assets/images/download-banner/appstore.png')}
              alt='appstore'
            />
          </a>
          <a
            href='https://play.google.com/store/apps/details?id=com.bonjoro.bonjoro&hl=en&gl=US'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              className='max-h-[40px]'
              src={assetUrl('assets/images/download-banner/playstore.png')}
              alt='playstore'
            />
          </a>
        </div>
      </div>
    </div>
  );
}
